const CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID
const ISSUER = process.env.REACT_APP_OKTA_ISSUER
const REDIRECT_URI = process.env.REACT_APP_OKTA_REDIRECT_URI

const oktaOidcConfigDetails = {
  clientId: CLIENT_ID,
  issuer: ISSUER,
  redirectUri: REDIRECT_URI,
  scopes: ["openid", "profile", "email"],
  pkce: false,
  cookies: {
    secure: false,
  },
}
export default oktaOidcConfigDetails;